import { Box, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { CustomPaper } from "../../../../../../../../components/CustomPaper"
import { KeyCaption } from "../../../../../../../../components/detailKeyValue/keyCaption.index"
import { useStyles } from "./styles"
import { ActivityAssignUser } from "./types"
import { ListTooltipDetail } from "../../../../../../../../components/listTooltipDetail"

export const UserDetailMySelf = ({ areas, departments, division, fullName, role, }: ActivityAssignUser) => {
    const { t } = useTranslation()
    const styles = useStyles()

    return (
        <CustomPaper elevation={2} sx={{ ...styles.container }}>
            <Box sx={styles.name}><Typography variant="title_grey_big">{fullName}</Typography></Box>
            <Box sx={styles.details}><KeyCaption value={t('general.tags.role')} caption={role || 'N/A'} /></Box>
            <Box sx={styles.details}><KeyCaption value={t('general.tags.division')} caption={division || 'N/A'} /></Box>
            <Box sx={styles.details}><KeyCaption value={t('general.tags.area')} caption={<ListTooltipDetail list={areas || []} />} /></Box>
            <Box sx={styles.details}><KeyCaption value={t('general.tags.department')} caption={<ListTooltipDetail list={departments || []} />} /></Box>
        </CustomPaper>
    )
}